import {extractSvgMarkup} from '../safe-svg.pipe';

/** Optional popular-listing / uploaded preview at row index 5 when API provides it. */
export function categoryRowImagePath(item: any[] | null | undefined): string | null {
  const raw = item?.[5];
  if (typeof raw !== 'string') {
    return null;
  }
  const path = raw.trim();
  if (!path || path.includes('<svg') || extractSvgMarkup(path)) {
    return null;
  }
  return path;
}

export function resolveCategoryImageUrl(
  item: any[] | null | undefined,
  imageBase: string | null | undefined,
): string | null {
  const path = categoryRowImagePath(item);
  if (!path) {
    return null;
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const base = `${imageBase || ''}`.replace(/\/+$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
